import React from 'react'
import styles from "../Modules/titletop.module.css";
import { Link, useNavigate } from "react-router-dom";


const TitleTop = () => {
  let navigate = useNavigate()
  const aboutTips = (e) => {
    navigate('/about');
  };
  return (
    <>
    <br /><br /><br />
    <div className='bg-dark' style={{position:'relative'}}>
        <img src="img1.jpg" alt="building" className={styles.img} />
             <div style={{position:'absolute',top: '100px',left: '25px'}}>
             <p className={styles.titlefont} >
             FOOD SUPPLY VISION <br />
             </p> <br />
             <div className={styles.subtitle}>
             
             Revolutionizing the grocery supply chain  <br />By creating a vertically integrated system
             <br />
             
              <button className={styles.greenbutton} onClick={aboutTips}>
                ABOUT US
              </button>  <br /><br />
             </div>
             </div>   
    </div>
    </>
  )
}

export default TitleTop